<template>
  <v-row>
    <slot name="before" />

    <v-col>
      <BFileInput
        v-bind="$attrs"
        :value="computedValue"
        :validate="validate"
        :disabled="disabled || isLoading"
        :skeleton="skeleton"
        :loading="isLoading"
        :label="label"
        small-chips
        show-size
        v-on="$listeners || {}"
        @change="onChange"
      >
        <template v-for="(_, key) in $scopedSlots" #[key]="props">
          <slot v-bind="props" :data="getData(props.item)" :name="key" />
        </template>
      </BFileInput>

      <div v-if="value && value.url" class="ml-8 pt-2">
        <v-btn text small :loading="isLoading" @click="onDownload">
          Скачать
        </v-btn>
      </div>
    </v-col>

    <slot name="after" />
  </v-row>
</template>

<script>
import BFileInput from '@/components/forms/BFileInput.vue'
import { downloadLinkByGet } from '@/helpers/downloadBlob'


export default {
  name: 'BFileUpload',
  components: {
    BFileInput,
  },
  inheritAttrs: false,
  props: {
    value: Object,
    disabled: Boolean,
    skeleton: Boolean,
    validate: [String, Object],
    label: {
      type: String,
      default: 'Файл',
    },
    visibleFileName: {
      type: String,
      default: '',
    },
    uploadFile: {
      type: Function,
    },
  },
  data: () => ({
    isLoading: false,
    file: null,
  }),
  computed: {
    computedValue() {
      if (this.visibleFileName && this.value.url) {
        return {
          ...this.value,
          name: this.visibleFileName,
        }
      }
      return this.value
    },
  },
  methods: {
    async onChange(file) {
      if (!this.uploadFile) {
        this.$emit('change', file)
        return
      }

      this.file = file
      if (!file) {
        this.$emit('input', null)
        return
      }

      this.isLoading = true

      const rawFile = {
        name: file.name,
        size: file.size,
        // url: URL.createObjectURL(file).toString(),
      }

      this.$emit('input', rawFile)

      try {
        const data = await this.uploadFile(file)
        const newFile = { ...rawFile, ...data }
        this.$emit('input', newFile)
      } catch {
        this.file = null
        this.$emit('input', null)
      }

      this.isLoading = false
    },
    async onDownload() {
      this.isLoading = true

      try {
        await downloadLinkByGet(this.value.url, this.visibleFileName, { isNewTab: true })
        this.isLoading = false
      } catch (e) {
        this.$notice.errors(e)
        this.isLoading = false
      }
    },
  },
}
</script>
